<div class="container">
  <div *ngIf="protocolos?.length">
    <br>
    <button [disabled]="protocolos?.length == 0" class="btn btn-secondary botaoMenor float-end" type="button" (click)="btnExportarProtocolosRenuncia()"
    placement="top" ngbTooltip="Exporta todas as solicitações listadas">
    <i class="fa fa-file"></i> Exportar protocolos</button>
    <br><br>
  </div>
</div>

<div class="container mt-3 mx-auto">
  <div class="alert alert-info" *ngIf="protocolos != undefined && protocolos.length < 1">
    Não foram encontrados protocolos com os filtros informados.
  </div>

  <div *ngIf="protocolos?.length">
    <bn-paginacao [total]="atributosPaginacao.count"
    [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
    [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

      <div class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th id="col-id-protocolo" scope="col" *ngIf="!cnpjAgente" class="col-md-3">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'nomeAgente'"
                    [nomeAtributoExibicao]="'Agente financeiro'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-id-protocolo" scope="col" class="col-md-2">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'idProtocoloNegocio'"
                    [nomeAtributoExibicao]="'ID protocolo'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-data-envio" scope="col" class="col-md-2">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'dataEnvio'" [nomeAtributoExibicao]="'Dt. solicitação'"
                  (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>
              <th id="col-status" scope="col" class="col-md-1">
                <bn-ordenacao [ordenacao]="atributosOrdenacao" [atributo]="'statusProtocolo'"
                  [nomeAtributoExibicao]="'Status'" (aoClickar)="mudancaOrdenacao($event)">
                </bn-ordenacao>
              </th>

              <th scope="col" class="col-md-2">
                  Arquivo envio
              </th>
              <th scope="col" class="col-md-2">
                  Arquivo resposta
              </th>
      
              <!--lupa para visualizar os detalhes-->
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let protocolo of protocolosPaginados">
              <td class="font-monospace" *ngIf="!cnpjAgente">{{ protocolo.nomeAgente }}</td>
              <td class="font-monospace">{{ protocolo.idProtocoloNegocio }}</td>
              <td>{{ protocolo.dataEnvio | date: 'dd/MM/yyyy HH:mm'}}</td>
              <td>{{ obterLabelStatusProtocolo(protocolo.statusProtocolo) }}</td>
              <td class="text-start">
                  <a href="javascript:void(0)" (click)="downloadArquivoEnvio(protocolo.idProtocoloNegocio)">
                    <span class="font-monospace fw-bold"> {{ protocolo.tamanhoConteudoEnvio | fileSize }} </span>
                    <i class="fa fa-download">
                    </i>
                  </a>
              </td>
              <td class="text-start">
                <span *ngIf="protocolo.tamanhoConteudoResposta; else conteudoRespostaNaoDisponivel">
                  <a href="javascript:void(0)" (click)="downloadArquivoResposta(protocolo.idProtocoloNegocio)">
                      <span class="font-monospace fw-bold"> {{ protocolo.tamanhoConteudoResposta | fileSize }} </span>
                      <i class="fa fa-download"></i>
                  </a>
                </span>
                  <ng-template #conteudoRespostaNaoDisponivel>
                    <span class="font-monospace">Não disponível</span>
                  </ng-template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </bn-paginacao>
  </div>
</div>



